// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

import { Environment } from '@anyx/shared-utils';

import { CoreEnvironment } from './types';

export const environment: CoreEnvironment = {
  appName: 'AnyX',
  env: Environment.PRODUCTION,
  enableDebug: false,
  google: {
    locationServiceEndpoint: 'https://api.app.any-x.com/rest/address',
  },
  auth0: {
    clientId: {
      ANYLOGI: 'C6bqEpLDjV2C3jaZgu2QHe1BUu89W3uu',
      ANYX: 'KQhziyb6XqxH8rVdRhbjN4TXjnOhBEhm',
      ANYCHAT: 'UiSA2F3TT9fZsufAZWAEP4baybCbNM7G',
    },
    domain: 'login.app.any-x.com',
    audience: 'https://gateway.app.any-x.com',
    permissions: 'https://gateway.app.any-x.com/permissions',
  },
  api: {
    graphql: 'https://gateway.app.any-x.com/graphql',
    graphqlws: 'wss://api.anychat.tech/ws/graphql',
    rest: 'https://api.app.any-x.com/rest',
  },
  help: {
    gitbook: 'https://anymind-group.gitbook.io/',
  },
  firebase: {
    config: {
      apiKey: process.env['NX_PUBLIC_FIREBASE_API_KEY'] || (() => { throw new Error('NX_PUBLIC_FIREBASE_API_KEY is required'); })(),
      authDomain: 'anyx-production.firebaseapp.com',
      projectId: 'anyx-production',
      storageBucket: 'anyx-production.appspot.com',
      messagingSenderId: '800533942669',
      appId: '1:800533942669:web:bd930417d5da301f5fadc4',
      measurementId: 'G-5N36EVTMP3',
    },
    remoteConfig: {
      minimumFetchIntervalMillis: 900000, // 15mins
    },
  },
};
